import { appURL } from '../../../../constants';

export default function ({ state }) {
    const { id } = state.get('app');
    state.set('app.continueURL', `${appURL}?id=${id}`);
}



// WEBPACK FOOTER //
// ./src/store/modules/app/actions/setContinueURL.js